import { RuleParamSchema } from "vee-validate/dist/types/types";
import { isUndefinedOrNullOrEmptyString } from "@/module/Validation/rules/isUndefinedOrNullOrEmptyString";

const validate = (value: any, { max }: Record<string, any>): boolean => {
  if (isUndefinedOrNullOrEmptyString(value)) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every((val) => validate(val, { max }));
  }

  value = String(value).replace(",", ".");

  if (value === "") {
    return false;
  }

  return Number(value) <= max;
};

const params: RuleParamSchema[] = [
  {
    name: "max",
  },
];

export { validate, params };

export default {
  validate,
  params,
};
